import { Stack } from '@mui/material';
import { IPaymentsAndDeductions } from 'API/paymentAndDeductions';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useEffect, useState } from 'react';
import { PaymentDeduction } from './PaymentDeduction';
import { FilteredCategories } from './FilteredCategories';
import { PaginationResult2 } from 'Components';
import { useIsDesktop } from 'Hooks';
interface IPaymentsDeductionList {
  filteredPaymentsDeductions: IPaymentsAndDeductions[];
  dispatchPaymentsDeductions: Function;
}

export const PaymentsDeductionList = ({
  filteredPaymentsDeductions,
  dispatchPaymentsDeductions,
}: IPaymentsDeductionList) => {
  const [pagination, setPagination] = useState<boolean>(false);
  const isDesktop = useIsDesktop();
  const paginationLimit = 10;

  useEffect(() => {
    setPagination(filteredPaymentsDeductions.length > paginationLimit);
  }, [filteredPaymentsDeductions]);

  return (
    <>
      <FilteredCategories
        resultNumber={filteredPaymentsDeductions.length}
        dispatchPaymentsDeductions={dispatchPaymentsDeductions}
      />
      <Stack direction='column' gap={isDesktop ? '48px' : '32px'}>
        <Stack gap={isDesktop ? '24px' : '20px'}>
          {filteredPaymentsDeductions.map(
            (item: IPaymentsAndDeductions, index: number) => {
              if (pagination && index >= paginationLimit) return null;
              return (
                <PaymentDeduction key={index} paymentDeductionItem={item} />
              );
            }
          )}
        </Stack>
        {pagination && (
          <PaginationResult2
            text={Dictionary[DICTIONARY.PaymentsDeductions].pagination}
            onClick={() => setPagination(false)}
          />
        )}
      </Stack>
    </>
  );
};
